document.addEventListener('change', function (e) {
  if (e.target.matches('.card__swatch input[type="radio"]')) {
    const radio = e.target;
    if (radio.checked) {
      const parentElement = radio.parentElement;
      const closestCard = radio.closest('.card');
      const cardImage = closestCard.querySelector('.media img:nth-child(1)');
      if (cardImage && parentElement.dataset.src) {
        cardImage.setAttribute('src', parentElement.dataset.src);
      }
      if (cardImage && parentElement.dataset.srcset) {
        cardImage.setAttribute('srcset', parentElement.dataset.srcset);
      }
    }
  }
});
